






























































































































































































































































































































import {
  EventManagementEventItemDTO,
  EventManagementEventService,
  EventManagementEventService as eventApi,
} from "@/common/api";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import {
  GENDER_ARRAY,
  ITEM_STATUS,
  ITEM_STATUS_ARRAY,
  ITEM_STATUS_NAME,
} from "@/model/event";
import PaginateModel from "@/model/paginate";
import { debounce } from "lodash";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const eventX = namespace("Event");

@Component({
  name: "EventSettingComponent",
  components: {
    QSearch,
    QMultiSelect,
    QErrors,
    QPaginate,
  },
})
export default class EventSettingComponent extends Vue {

  get allEventItemsNoMember(): boolean {
    return !this.allEventItems.some(
      (item) => item.status === ITEM_STATUS.SOLDOUT && item.member,
    );
  }

  get paginatedEventItems() {
    const start = (this.currentPage - 1) * this.itemByPage;
    const end = this.currentPage * this.itemByPage;
    return this.eventItems.slice(start, end);
  }

  get startPage(): number {
    return (this.currentPage - 1) * this.itemByPage + 1 || 0;
  }

  get endPage(): number {
    return (
      Math.min(this.currentPage * this.itemByPage, this.eventItems.length) || 0
    );
  }

  get frontNaritaUrl(): string {
    return process.env.VUE_APP_NARITA_URL || "";
  }
  public title = "抽選結果登録";
  public errors = [];

  public selectedAllStatus = { id: "all", name: "すべてのステータス" };
  public statuses = [...[this.selectedAllStatus], ...ITEM_STATUS_ARRAY];
  public winnerStatuses = [...ITEM_STATUS_ARRAY];
  public producers = [];
  public kinds = [];
  public genders = [];
  public initialSearch = {
    code: null,
    status: ["all"],
    sex: "",
    producer: "",
    kind: "",
    price: null,
  };
  public searchParams: any = {};

  public allEventItems: EventManagementEventItemDTO[] = [];
  public eventItems: EventManagementEventItemDTO[] = [];

  public displayThumb = 0;

  public currentPage = 1;
  public paginateTotal = 1;
  public itemByPage = 200;
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });
  private eventId;

  private debouncedHandlers: Map<number, (val: number) => void> = new Map();

  public created() {
    this.eventId = Number(this.$router.currentRoute.params.id);
  }

  public mounted() {
    this.displayThumb = Number(localStorage.getItem("displayThumb") ?? 0);
    this.clearSearchParams();
    this.getList({ id: this.eventId });
  }

  public filterData(): void {
    const filtered = this.allEventItems.filter((item) => {
      // code
      if (
        this.searchParams.code &&
        !String(item.code).includes(String(this.searchParams.code))
      ) {
        return false;
      }
      // status
      if (
        this.searchParams.status &&
        !this.searchParams.status.includes("all") &&
        !this.searchParams.status.includes(item.status)
      ) {
        return false;
      }
      // producer
      if (
        this.searchParams.producer &&
        item.producer !== this.searchParams.producer
      ) {
        return false;
      }
      // kind
      if (this.searchParams.kind && item.kind !== this.searchParams.kind) {
        return false;
      }
      // sex
      if (this.searchParams.sex && item.sex !== this.searchParams.sex) {
        return false;
      }
      // price
      if (
        this.searchParams.price &&
        !(
          Number(item.price) <= Number(this.searchParams.price) ||
          Number(item.final_price) <= Number(this.searchParams.price)
        )
      ) {
        return false;
      }
      return true;
    });

    this.eventItems = filtered;
    this.paginateTotal = Math.ceil(this.eventItems.length / this.itemByPage);
    if (this.currentPage > this.paginateTotal) {
      this.currentPage = 1;
    }
    this.pagination = new PaginateModel({
      page: this.currentPage,
      pageCount: this.paginateTotal,
      start: (this.currentPage - 1) * this.itemByPage + 1,
      end: Math.min(this.currentPage * this.itemByPage, this.eventItems.length),
      count: this.eventItems.length,
    });
  }

  public async getList(query) {
    let message: any;
    try {
      if (query.status && query.status.includes("all")) {
        query.status = [];
      }
      if (!Array.isArray(query.status)) {
        query.status = [query.status];
      }

      const { data } = await eventApi.adminEventSetting(query);
      this.title = data.title + "の抽選結果登録";
      this.producers = data.producers;
      this.kinds = data.kinds;
      this.genders = data.genders;
      this.allEventItems = data.eventItems.map((item) => ({
        ...item,
        _form: {
          winnerStatus: item.status,
          eventNumber: item.member ? item.member.event_number : "",
          finalPrice: item.final_price,
        },
        _showEntryList: false,
      }));
      this.eventItems = [...this.allEventItems];
      this.paginateTotal = Math.ceil(this.eventItems.length / this.itemByPage);
      if (this.currentPage > this.paginateTotal) {
        this.currentPage = 1;
      }
      this.pagination = new PaginateModel({
        page: this.currentPage,
        pageCount: this.paginateTotal,
        start: (this.currentPage - 1) * this.itemByPage + 1,
        end: Math.min(
          this.currentPage * this.itemByPage,
          this.eventItems.length,
        ),
        count: this.eventItems.length,
      });
    } catch (error) {
      message = error.body.message;
      QNotify.error({
        text: message,
      });
    }
  }

  public async updateEventItem(eventItem) {
    this.errors = [];
    let result;
    try {
      result = await eventApi.adminEventSettingEdit({
        id: eventItem.id,
        winnerStatus: eventItem._form.winnerStatus,
        eventNumber: eventItem._form.eventNumber,
        finalPrice: eventItem._form.finalPrice,
      });

      if (result.status == "success") {
        QNotify.success({
          text: "更新しました",
        });

        const allIndex = this.allEventItems.findIndex(
          (item) => item.id === eventItem.id,
        );
        const eventIndex = this.eventItems.findIndex(
          (item) => item.id === eventItem.id,
        );

        if (allIndex !== -1) {
          this.$set(this.allEventItems, allIndex, result.data.eventItem);
        }
        if (eventIndex !== -1) {
          this.$set(this.eventItems, eventIndex, result.data.eventItem);
        }

        for (const item of [
          this.allEventItems[allIndex],
          this.eventItems[eventIndex],
        ]) {
          if (item) {
            this.$set(item, "_form", {
              winnerStatus: item.status,
              eventNumber: item.member ? item.member.event_number : "",
              finalPrice: item.final_price,
            });
            this.$set(item, "_showEntryList", false);
          }
        }
      }
    } catch (error) {
      result = error;
      QNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.$set(this.errors, eventItem.id, error.body.errors);
      }
    }
  }

  public async reDraw() {
    this.errors = [];
    let result;
    try {
      result = await eventApi.adminEventSettingReDraw({
        id: this.eventId,
      });

      if (result.status == "success") {
        QNotify.success({
          text: "更新しました",
        });
        this.getList({ id: this.eventId });
      }
    } catch (error) {
      result = error;
      QNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
      }
    }
  }

  public async allSold() {
    this.errors = [];
    let result;
    try {
      result = await eventApi.adminEventSettingAllSold({
        id: this.eventId,
      });

      if (result.status == "success") {
        QNotify.success({
          text: "更新しました",
        });
        this.getList({ id: this.eventId });
      }
    } catch (error) {
      result = error;
      QNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
      }
    }
  }

  public listPrint() {
    window.open(`/setting/print/${this.eventId}?mode=all`, "_blank");
  }

  public resetSearch() {
    this.clearSearchParams();
    this.filterData();
  }

  public clearSearchParams() {
    this.searchParams = { ...this.initialSearch };
  }

  public cancel() {
    this.$router.back();
  }

  public getStatus(status): string {
    return ITEM_STATUS_NAME[status] ? ITEM_STATUS_NAME[status] : "";
  }

  public getGenderName(gender): string {
    const found = GENDER_ARRAY.find((g) => g.id === gender);
    return found ? found.name : "";
  }

  public changeDisplayThumb() {
    localStorage.setItem("displayThumb", String(this.displayThumb));
  }

  public isChangedEventNumber(eventItem): boolean {
    if (
      eventItem.member &&
      eventItem._form.eventNumber != eventItem.member.event_number
    ) {
      return true;
    }
    if (!eventItem.member && eventItem._form.eventNumber) {
      return true;
    }
    return false;
  }

  public showConfirm() {
    this.$modal.showDelete({
      title: "再抽選",
      text: "すべての当選者情報がリセットされます。",
      confirmText: "実行",
      onConfirm: () => {
        this.reDraw();
      },
    });
  }
  public showUrikireConfirm() {
    this.$modal.show({
      title: "すべてを成約済みにする",
      text: "すべての鯉のステータスを成約済みに変更します。",
      confirmText: "実行",
      onConfirm: () => {
        this.allSold();
      },
    });
  }

  public showCreateSecondEventConfirm() {
    this.$modal.show({
      title: "延長戦",
      text: "販売中の鯉を複製して新しいイベントを作成します。複製した鯉は元のイベントから削除されます。",
      confirmText: "実行",
      onConfirm: () => {
        this.createSecondEvent();
      },
    });
  }

  public async createSecondEvent() {
    this.errors = [];
    let result;
    try {
      result = await eventApi.adminEventCreateSecondEvent({
        id: this.eventId,
      });

      if (result.status == "success") {
        const newEventId = result.data.newEvent.id;
        this.$modal.show({
          title: "延長戦イベント作成完了",
          text: "延長戦イベントを作成しました。",
          confirmText: "新しいイベントを開く",
          cancelText: "閉じる",
          showQuestion: false,
          onConfirm: () => {
            window.location.href = `/event/edit/${newEventId}`;
          },
        });
      }
    } catch (error) {
      result = error;
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  public updateCurrent(pageOrQuery: number | { page: number }) {
    if (typeof pageOrQuery === "object" && pageOrQuery.page) {
      this.currentPage = Number(pageOrQuery.page);
    } else {
      this.currentPage = Number(pageOrQuery);
    }
    this.pagination = new PaginateModel({
      page: this.currentPage,
      pageCount: this.pagination.pageCount,
      start: this.pagination.start,
      end: this.pagination.end,
      count: this.pagination.count,
    });
  }

  public handleChangeStatus(item) {
    const form = item._form;
    if (form.winnerStatus === ITEM_STATUS.SOLDOUT) {
      this.$set(item, "_form", {
        winnerStatus: form.winnerStatus,
        eventNumber: item.member ? item.member.event_number : "",
        finalPrice: item.final_price,
      });
    } else {
      this.$set(item, "_form", {
        winnerStatus: form.winnerStatus,
        eventNumber: "",
        finalPrice: "",
      });
    }
  }

  public async onEventNumberInput(eventItem: any, val: number) {
    if (!this.debouncedHandlers.has(eventItem.id)) {
      const handler = debounce(async (value: number) => {
        try {
          const result =
            await EventManagementEventService.adminEventGetMemberByEventNumber({
              eventNumber: value,
            });

          eventItem.member = result.data.event_member;
        } catch (error) {
          eventItem.member.full_name = "---";
          eventItem.member.tel = "";
        }
      }, 1000);
      this.debouncedHandlers.set(eventItem.id, handler);
    }

    this.debouncedHandlers.get(eventItem.id)!(val);
  }

  public selectTel(event): void {
    const el = event.currentTarget;
    const range = document.createRange();
    const selection = window.getSelection();

    if (!el) { return; }
    range.selectNodeContents(el);
    selection.removeAllRanges();
    selection.addRange(range);
  }
}
